import { MyAccessDto } from '../types/MyAccessDto';

export type EntryTarget = 'app' | 'workspaces' | 'complete-profile';

/**
 * Gdzie trafia zweryfikowany użytkownik po wejściu do aplikacji. Jedna firma bez zaproszeń
 * idzie prosto do środka, żeby nowy ekran nie dotknął nikogo, kto go nie potrzebuje.
 */
export const resolveEntryTarget = (
  me: MyAccessDto | undefined,
  storedCompanyId: string | null,
): EntryTarget => {
  const accesses = me?.accesses ?? [];
  const invitations = me?.invitations ?? [];
  if (accesses.length === 0) {
    return invitations.length === 0 ? 'complete-profile' : 'workspaces';
  }
  if (accesses.length === 1 && invitations.length === 0) return 'app';
  return accesses.some((a) => a.companyId === storedCompanyId)
    ? 'app'
    : 'workspaces';
};
